import BlockComponentButton from '../../../models/BlockComponentValues/BlockComponentButton';
import BlockSettings from '../../../models/BlockSettings';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockButtonListData {
  buttonList: BlockComponentButton[];
  settings: BlockSettings;
  url?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockButtonListData {
  export function make(buttonList: BlockComponentButton[], settings: BlockSettings, url?: string): BlockButtonListData {
    return {
      buttonList,
      settings: BlockSettings.make(settings.align, settings.justify),
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(): BlockButtonListData {
    return make(
      [
        BlockComponentButton.getDefault(),
        BlockComponentButton.getDefault(),
        BlockComponentButton.getDefault(),
        BlockComponentButton.getDefault(),
      ],
      BlockSettings.getDefault(),
    );
  }
}

export default BlockButtonListData;
